
//const slider = new Swiper(".slider", {
//  //navigation: {
//  //  nextEl: ".swiper-button-next",
//  //  prevEl: ".swiper-button-prev",
//  //},
//  //effect: 'fade',
//  autoplay: {
//    delay: 6000,
//  },
//  loop: true,
//  navigation: {
//    nextEl: ".swiper-button-next",
//    prevEl: ".swiper-button-prev",
//  //},
//  //thumbs: {
//  //  swiper: sliderThumbnail
//  }
//});
//
//// thumbnailを追従させたくないので、slideToメソッドでサムネイルと連動
//function thumbnail(index) {
//  slider.slideTo(index);
//}
//サムネイル
var sliderThumbnail = new Swiper('.slider-thumbnail', {
  slidesPerView: 3,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slidesPerView: "auto",
  slideToClickedSlide: false,
  loop: false,
  threshold: 5,
});

//スライダー
var slider = new Swiper('.slider', {
  loop: true,
  autoplay: {
    delay: 6000,
  },
  thumbs: {
    swiper: sliderThumbnail
  },
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false, 
  touchStartPreventDefault: false, 
  threshold: 10,
});
document.querySelectorAll('.slider .swiper-slide a').forEach(link => {
  link.addEventListener('click', e => {
    e.stopPropagation();
    e.preventDefault();
    const href = link.getAttribute('href');
    if (href) window.location.href = href;
  });
});